import type { PayloadAction } from "@reduxjs/toolkit";
import { DUMMY_ADMIN_USER } from "Data/Dummy/User";
import { createAppSlice } from "Data/Redux/Store";
import type { LoginPayload, LoginResponse, UserState } from "Interfaces";

const initialState: UserState = {
	token: "",
	user: null
};

// #region Thunk Functions
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const loginUserThunk = async (payload: LoginPayload) => {
	return {
		token: "authToken",
		user: DUMMY_ADMIN_USER
	};
};
// #endregion

// #region User Reducers
export const loginReducer = (state: UserState, action: PayloadAction<LoginResponse>) => {
	const { user, token } = action.payload;

	if (!user || !token) {
		return;
	}

	state.token = token;
	state.user = user;
};

export const logoutReducer = (state: UserState) => {
	state.token = "";
	state.user = null;
};
// #endregion

// #region User Selectors
export const getToken = (state: UserState) => {
	return state.token;
};

export const getUser = (state: UserState) => {
	return state.user;
};
// #endregion

const userSlice = createAppSlice({
	name: "user",
	initialState,
	reducers: (create) => ({
		loginUserAction: create.asyncThunk(
			loginUserThunk,
			{
				fulfilled: loginReducer
			}
		),
		logoutUserAction: create.reducer(logoutReducer)
	}),
	selectors: {
		selectCurrentUser: getUser,
		selectToken: getToken
	}
});

export default userSlice;

export const { loginUserAction, logoutUserAction } = userSlice.actions;
export const { selectCurrentUser, selectToken } = userSlice.selectors;
